import { EmptyState } from "../../components/index.ts";
import { OfficePage, runsBusiness } from "../office.tsx";
import { WhatsAppSyncBody } from "./sync-tool.tsx";

/**
 * Its own file, not in tools.tsx, so Control Center can mount it without the Tools page and its
 * Team photo link (Control Center has no Team photo page).
 */

/** The WhatsApp sync tool as a page. Members, Team and the setup import step open the same body in a panel. */
export function OwnerWhatsAppSyncScreen() {
  return (
    <OfficePage
      title="WhatsApp sync"
      description="Bring the people of your WhatsApp groups into Teamna. Then choose who each person is."
    >
      {(business) =>
        runsBusiness(business) ? (
          <div>
            <WhatsAppSyncBody businessId={business.businessId} />
          </div>
        ) : (
          <EmptyState title="Owner and admin only" message="Ask the owner to sync the WhatsApp groups." />
        )
      }
    </OfficePage>
  );
}
